import {SettingsCard} from '@features/settings/components/settings-card'
import {useTranslation} from '@/translations/i18n.tsx'
import {useMe} from '@features/user/queries/useMe.ts'
import {raise} from '@utilities/helpers.ts'
import {ProfilePicturePicker} from '@features/settings/components/profile-image-picker'
import {useState} from 'react'
import {ChangeDescriptionModal} from '@features/settings/components/change-description-modal'
import {Button} from '@components/ui/button'
import {Badge} from '@components/ui/badge'

export const PersonalInformation = () => {
    const {t} = useTranslation()
    const userMeQuery = useMe({throwOnError: true})
    const user = userMeQuery.data ?? raise('user is nullish')
    const [isChangeDescriptionModalOpen, setIsChangeDescriptionModalOpen] = useState(false)
    const isCompleted = !!user.description

    return (
        <div className="flex flex-col gap-4">
            <ProfilePicturePicker user={user} />

            <div className="flex flex-col gap-2.5">
                <div className="flex flex-col flex-wrap items-start gap-2.5 md:flex-row md:items-center">
                    <span className="text-display-sm font-medium">
                        {user.firstName} {user.lastName}
                    </span>
                    <div className="flex flex-wrap items-start gap-2.5 md:items-center">
                        {user.isCreator && (
                            <Badge shape="rectangle">{t(`settings:personal_information:creator`)}</Badge>
                        )}
                        {user.isInspector && (
                            <Badge shape="rectangle">{t(`settings:personal_information:inspector`)}</Badge>
                        )}
                    </div>
                </div>
                <SettingsCard isCompleted={isCompleted}>
                    <h3>{isCompleted ? `“${user.description}”` : t('settings:personal_information:intro_text')}</h3>

                    <Button onClick={() => setIsChangeDescriptionModalOpen(true)} variant="tertiary" shape="text">
                        {t(isCompleted ? 'commons:edit' : 'settings:personal_information:intro_action')}
                    </Button>
                </SettingsCard>
                <small className="text-sm text-neutral-600">{t('settings:personal_information:info_message')}</small>
            </div>

            {isChangeDescriptionModalOpen && (
                <ChangeDescriptionModal
                    onClose={() => setIsChangeDescriptionModalOpen(false)}
                    userDescription={user.description}
                    userId={user.id}
                />
            )}
        </div>
    )
}
